// extracted by mini-css-extract-plugin
export default {"overlay":"PostImage-overlay__1G"};